import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TipoEventoService } from './tipo-evento-service/tipo-evento.service';

@Component({
  selector: 'app-tipo-evento',
  templateUrl: './tipo-evento.component.html',
  styleUrls: ['./tipo-evento.component.css']
})
export class TipoEventoComponent implements OnInit {

  carregando = true;
  tipoEventos: any[] = [];
  display: boolean = false;
  nomeNovoTipoEvento: string = '';
  
  displayConfirmarExclusao: boolean = false;
  tipoEventoParaExcluir: any = null;
  
  displayVinculos: boolean = false;
  carregandoVinculos: boolean = false;
  tipoEventoSelecionado: any = null;
  elementosDisponiveis: any[] = [];
  elementosVinculados: any[] = [];
  elementosDisponiveisFiltrados: any[] = [];
  elementosVinculadosFiltrados: any[] = [];
  alteracoesVinculos: boolean = false;
  termoPesquisaDisponiveis: string = '';
  termoPesquisaVinculados: string = '';
  

  constructor(
    private serviceTipoEvento: TipoEventoService,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.carregando = true;
    this.carregarTipoEventos();
  }

  showDialog() {
    this.display = true;
  }

  hideDialog() {
    this.display = false;
  }

  carregarTipoEventos() {
    this.carregando = true;
    this.tipoEventos = [];
    
    this.serviceTipoEvento.getTipoEventos()
      .then((response: any) => {
        
        const dadosTipoEventos = Array.isArray(response?.data) ? response.data : response;

        if (dadosTipoEventos && Array.isArray(dadosTipoEventos)) {
          this.tipoEventos = dadosTipoEventos.map((tipoEvento: any) => ({
            id: tipoEvento.idTipoEvento ?? tipoEvento.id,
            nome: tipoEvento.descEventoFab ?? tipoEvento.descTipoEvento ?? tipoEvento.nome,
            vinculos: tipoEvento.countVinculados ?? tipoEvento.vinculos ?? 0,
            contemFabrica: !!(tipoEvento.contemFabrica ?? tipoEvento.contem_fabrica)
          }));
        }
        this.carregando = false;
      })
      .catch((error: any) => {
        this.carregando = false;
        console.error('Erro ao carregar tipo eventos:', error); // Debug
        this.tratarErro(
          this.translate.instant('parametros.tipoEvento.erroCarregarTipoEventos'),
          this.translate.instant('parametros.tipoEvento.erro'),
          error
        );
      });
  }


  adicionarTipoEvento(nomeTipoEvento: string) {
    if (!nomeTipoEvento || nomeTipoEvento.trim() === '') {
      this.exibirErro(this.translate.instant('parametros.tipoEvento.nomeObrigatorio'), this.translate.instant('parametros.tipoEvento.erro'));
      return;
    }

    // Verificar se já existe um tipo de evento com este nome
    const tipoEventoExistente = this.tipoEventos.find(f => 
      f.nome.toLowerCase() === nomeTipoEvento.toLowerCase()
    );

    if (tipoEventoExistente) {
      this.exibirErro(this.translate.instant('parametros.tipoEvento.tipoEventoJaExiste'), this.translate.instant('parametros.tipoEvento.erro'));
      return;
    }

    // Chamada para o backend para criar o tipo de evento
    this.serviceTipoEvento.adicionarTipoEvento(nomeTipoEvento.trim())
      .then((response: any) => {
        
        this.exibirSucesso(
          this.translate.instant('parametros.tipoEvento.tipoEventoAdicionado'), 
          this.translate.instant('parametros.tipoEvento.sucesso')
        );
        this.limparFormulario();
        this.hideDialog();
        
        // Recarregar a lista de tipos de evento após adicionar
        this.carregarTipoEventos();
      })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.tipoEvento.erroAdicionarTipoEvento'),
          this.translate.instant('parametros.tipoEvento.erro'),
          error
        );
      });
  }

  private limparFormulario() {
    this.nomeNovoTipoEvento = '';
  }

  removerTipoEvento(idTipoEvento: number) {
    const index = this.tipoEventos.findIndex(f => f.id === idTipoEvento);
    if (index > -1) {
      const tipoEventoRemovido = this.tipoEventos[index];
      
      // Verificar se há vínculos ativos
      if (tipoEventoRemovido.vinculos > 0) {
        const mensagem = this.translate.instant('parametros.tipoEvento.naoPodeRemoverComVinculos')
          .replace('{nome}', tipoEventoRemovido.nome)
          .replace('{vinculos}', tipoEventoRemovido.vinculos.toString());
        this.exibirErro(mensagem, this.translate.instant('parametros.tipoEvento.avisoVinculosAtivos'));
        return;
      }

      // Mostrar modal de confirmação
      this.tipoEventoParaExcluir = tipoEventoRemovido;
      this.displayConfirmarExclusao = true;
    }
  }

  confirmarExclusao() {
    if (!this.tipoEventoParaExcluir) return;

    // Chamada para o backend para remover o tipo de evento
    this.serviceTipoEvento.removerTipoEvento(this.tipoEventoParaExcluir.id)
      .then((response: any) => {
        this.exibirSucesso(
          this.translate.instant('parametros.tipoEvento.tipoEventoRemovido'), 
          this.translate.instant('parametros.tipoEvento.sucesso')
        );
        this.hideDialogConfirmarExclusao();
        
        // Recarregar a lista de tipos de evento após remover
        this.carregarTipoEventos();
      })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.tipoEvento.erroRemoverTipoEvento'),
          this.translate.instant('parametros.tipoEvento.erro'),
          error
        );
      });
  }

  hideDialogConfirmarExclusao() {
    this.displayConfirmarExclusao = false;
    this.tipoEventoParaExcluir = null;
  }

  verVinculos(tipoEvento: any) {
    this.tipoEventoSelecionado = tipoEvento;
    
    // Inicializar com arrays vazios para garantir que o modal abra
    this.elementosDisponiveis = [];
    this.elementosVinculados = [];
    this.elementosDisponiveisFiltrados = [];
    this.elementosVinculadosFiltrados = [];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
    
    // Ativar loading
    this.carregandoVinculos = true;
    
    // Abrir o modal primeiro
    this.displayVinculos = true;
    
    // Depois carregar os dados
    this.carregarElementosVinculos(tipoEvento.id);
  }

  carregarElementosVinculos(tipoEventoId: number) {
    // Chamada para o backend para buscar os vínculos do tipo de evento
    this.serviceTipoEvento.getVinculosTipoEvento(tipoEventoId)
      .then((response: any) => {
        
        // Verificar se a resposta tem a estrutura esperada
        let dadosVinculos = response;
        
        // Se a resposta estiver dentro de response.data, usar response.data
        if (response && response.data) {
          dadosVinculos = response.data;
        }
        
        // Se não há dados, inicializar com arrays vazios
        if (!dadosVinculos) {
          dadosVinculos = {
            disponiveis: [],
            vinculados: []
          };
        }
        
        this.processarVinculosTipoEvento(dadosVinculos);
        this.carregandoVinculos = false; // Desativar loading
      })
      .catch((error: any) => {
        console.error('Erro ao carregar vínculos:', error); // Debug
        this.carregandoVinculos = false; // Desativar loading mesmo em caso de erro
        this.tratarErro(
          this.translate.instant('parametros.tipoEvento.erroCarregarVinculos'),
          this.translate.instant('parametros.tipoEvento.erro'),
          error
        );
      });
  }

  private processarVinculosTipoEvento(dadosVinculos: any) {
    // Processar os dados de vínculos recebidos da API
    
    // Converter arrays de objetos para o formato interno
    this.elementosDisponiveis = (dadosVinculos.disponiveis || []).map((item: any, index: number) => ({
      id: `disp_${index}`,
      nome: item.descTipoEvento,
      vinculado: false,
      contemFabrica: item.contemFabrica
    }));
    
    this.elementosVinculados = (dadosVinculos.vinculados || []).map((item: any, index: number) => ({
      id: `vinc_${index}`,
      nome: item.descTipoEvento,
      vinculado: true,
      contemFabrica: item.contemFabrica
    }));

    // Inicializar listas filtradas
    this.elementosDisponiveisFiltrados = [...this.elementosDisponiveis];
    this.elementosVinculadosFiltrados = [...this.elementosVinculados];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
  }


  adicionarVinculo(elemento: any) {
    if (elemento.vinculado) return;

    // Remover da lista de disponíveis
    const index = this.elementosDisponiveis.findIndex(e => e.id === elemento.id);
    if (index > -1) {
      this.elementosDisponiveis.splice(index, 1);
    }

    // Adicionar à lista de vinculados
    elemento.vinculado = true;
    this.elementosVinculados.push(elemento);

    // Atualizar listas filtradas
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();

    this.alteracoesVinculos = true;
  }

  removerVinculo(elemento: any) {
    // Remover da lista de vinculados
    const index = this.elementosVinculados.findIndex(e => e.id === elemento.id);
    if (index > -1) {
      this.elementosVinculados.splice(index, 1);
    }

    // Adicionar à lista de disponíveis
    elemento.vinculado = false;
    this.elementosDisponiveis.push(elemento);

    // Atualizar listas filtradas
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();

    this.alteracoesVinculos = true;
  }

  // Métodos para pesquisa e ações em massa
  filtrarElementosDisponiveis() {
    if (!this.termoPesquisaDisponiveis || this.termoPesquisaDisponiveis.trim() === '') {
      this.elementosDisponiveisFiltrados = [...this.elementosDisponiveis];
    } else {
      const termo = this.termoPesquisaDisponiveis.toLowerCase().trim();
      this.elementosDisponiveisFiltrados = this.elementosDisponiveis.filter(elemento =>
        elemento.nome.toLowerCase().includes(termo) ||
        (elemento.criadoPor && elemento.criadoPor.toLowerCase().includes(termo))
      );
    }
  }

  filtrarElementosVinculados() {
    if (!this.termoPesquisaVinculados || this.termoPesquisaVinculados.trim() === '') {
      this.elementosVinculadosFiltrados = [...this.elementosVinculados];
    } else {
      const termo = this.termoPesquisaVinculados.toLowerCase().trim();
      this.elementosVinculadosFiltrados = this.elementosVinculados.filter(elemento =>
        elemento.nome.toLowerCase().includes(termo) ||
        (elemento.criadoPor && elemento.criadoPor.toLowerCase().includes(termo))
      );
    }
  }

  limparPesquisaDisponiveis() {
    this.termoPesquisaDisponiveis = '';
    this.filtrarElementosDisponiveis();
  }

  limparPesquisaVinculados() {
    this.termoPesquisaVinculados = '';
    this.filtrarElementosVinculados();
  }

  vincularTodosFiltrados() {
    if (this.elementosDisponiveisFiltrados.length === 0) return;

    // Vincular todos os elementos filtrados
    const elementosParaVincular = [...this.elementosDisponiveisFiltrados];
    
    elementosParaVincular.forEach(elemento => {
      if (!elemento.vinculado) {
        // Remover da lista de disponíveis
        const index = this.elementosDisponiveis.findIndex(e => e.id === elemento.id);
        if (index > -1) {
          this.elementosDisponiveis.splice(index, 1);
        }

        // Adicionar à lista de vinculados
        elemento.vinculado = true;
        this.elementosVinculados.push(elemento);
      }
    });

    // Atualizar listas filtradas
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  removerTodosVinculos() {
    if (this.elementosVinculados.length === 0) return;

    const totalRemovidos = this.elementosVinculados.length;

    // Remover todos os vínculos
    this.elementosVinculados.forEach(elemento => {
      elemento.vinculado = false;
      this.elementosDisponiveis.push(elemento);
    });

    this.elementosVinculados = [];

    // Atualizar listas filtradas
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;


  }

  salvarVinculos() {
    if (!this.alteracoesVinculos) return;

    // Chamada para a API para salvar os vínculos
    this.serviceTipoEvento.salvarVinculosTipoEvento(this.tipoEventoSelecionado.id, this.elementosVinculados)
      .then((response: any) => {
        // Atualizar o contador local
        this.tipoEventoSelecionado.vinculos = this.elementosVinculados.length;
        
        // Atualizar também na lista principal de tipos de evento
        const tipoEventoIndex = this.tipoEventos.findIndex(f => f.id === this.tipoEventoSelecionado.id);
        if (tipoEventoIndex > -1) {
          this.tipoEventos[tipoEventoIndex].vinculos = this.elementosVinculados.length;
        }
        
        this.exibirSucesso(
          this.translate.instant('parametros.tipoEvento.vinculosSalvos'), 
          this.translate.instant('parametros.tipoEvento.sucesso')
        );

        this.alteracoesVinculos = false;
        this.hideDialogVinculos();
      })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.tipoEvento.erroSalvarVinculos'),
          this.translate.instant('parametros.tipoEvento.erro'),
          error
        );
      });
  }

  hideDialogVinculos() {
    this.displayVinculos = false;
    this.carregandoVinculos = false;
    this.tipoEventoSelecionado = null;
    this.elementosDisponiveis = [];
    this.elementosVinculados = [];
    this.elementosDisponiveisFiltrados = [];
    this.elementosVinculadosFiltrados = [];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
  }

  // TrackBy function para otimizar performance
  trackByElemento(index: number, elemento: any): number {
    return elemento.id;
  }

  exibirSucesso(mensagem: string, titulo: string) {
    this.toastr.success(mensagem, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }

  exibirErro(mensagem: string, titulo: string) {
    this.toastr.error(mensagem, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }

  tratarErro(mensagem: string, titulo: string, error: any) {
    this.carregando = false;
    console.error(error);
    let msg: string;
    try {
      if (error.status === 401) {
        this.router.navigateByUrl('logout');
      }
      msg = mensagem + '\n' + error.erro;
    } catch (Exception) {
      msg = mensagem;
    }
    this.toastr.error(msg, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }
}
